module.exports = __webpack_public_path__ + "static/media/alerts.01256310.svg";